<template>
    <a-drawer title="选择图标" :visible="visible" :wrap-class-name="drawerWrapClassName" destroy-on-close
              @close="onClose" :width="1200">
        <div class="ant-drawer-main">
            <a-row>
                <template v-for="(item) in iconList" :key="item.name">
                    <a-col :span="2">
                        <div class="icon-item"
                             :class="{'on':isActive(item.name)}"
                             @click="onIconClick(item.name)"
                        >
                            <div class="icon">
                                <icon-font :type="`${item.icon}`"/>
                            </div>
                            <div class="icon-name">{{ item.name }}</div>
                        </div>
                    </a-col>
                </template>
            </a-row>
        </div>
        <div class="ant-drawer-footer">
            <a-button @click="onClose">取消</a-button>
            <a-button type="primary" @click="onChange">确定</a-button>
        </div>
    </a-drawer>
</template>

<script>
import {popupMixin} from "@/mixins";
import {iconList} from "@/utils/iconFontNames";

export default {
    name: "IconDrawer",
    mixins: [popupMixin],
    props: {
        value: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            iconList,
            currentIcon: ''
        }
    },
    watch: {
        value(value) {
            this.currentIcon = value;
        }
    },
    methods: {
        isActive(name) {
            return name === this.currentIcon;
        },
        onIconClick(name) {
            this.currentIcon = name;
        },
        onChange() {
            this.$emit('update:value', this.currentIcon);
            this.onClose();
        }
    }
}
</script>

<style scoped lang="less">
.icon-item {
    height: 100px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    user-select: none;
    cursor: pointer;
    border-width: 1px;
    border-style: dashed;
    border-color: transparent;

    .icon {
        font-size: 36px;
    }

    .icon-name {
        width: 100%;
        padding: 0 10px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    &.on {
        border-color: #409eff;
        color: #409eff;
    }
}
</style>
